import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  type StackProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)<StackProps>(({ theme }) => ({
  alignItems: "stretch",
  scrollMarginTop: theme.spacing(2),
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "none",
  backgroundImage: "none",
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: 0,
  },
}));

export const Summary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: 48,
  padding: theme.spacing(0, 2),
  "&.Mui-expanded": {
    minHeight: 48,
  },
  "& .MuiAccordionSummary-content": {
    margin: theme.spacing(1.5, 0),
    alignItems: "center",
    gap: theme.spacing(1),
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: theme.spacing(1.5, 0),
  },
}));

export const Details = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0, 2, 2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const PlatformBlock = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(1),
  "& + &": {
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));
